<template>

  <v-app-bar app flat absolute elevation="10" class="transparent-navbar text-white">

    <template v-slot:prepend >
      <div class="ml-1 font-weight-bold text-h6">
      <v-icon large class="mr-1">mdi-camera</v-icon>
      Majed Photograph
      </div>
    </template>

    <template v-slot:append>
      <div class="hidden-sm-and-down text-white">
        <v-btn text @click="scrollToSection('PROJECTS')">Projekte</v-btn>
        <v-btn text @click="scrollToSection('METHODOLOGY')">Methodik</v-btn>
        <v-btn text @click="scrollToSection('AQ')">Q&A</v-btn>
        <v-btn text @click="scrollToSection('ABOUT_ME')">Über mich</v-btn>
        <v-btn text @click="scrollToSection('CONTACT')">Kontakt</v-btn>
      </div>

    <v-app-bar-nav-icon 
      @click="drawer = true" 
      class="hidden-md-and-up text-h6 "
    ></v-app-bar-nav-icon>
   
    
    <NavbarPageComponent v-model:isActive="drawer" />

    </template>
    
  </v-app-bar>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import NavbarPageComponent from './NavbarPageComponent.vue';
import { scrollService } from '@/services/scrollService';

export default defineComponent({
  name: 'NavbarComponent',
  
  components: {
    NavbarPageComponent
  },

  data() {
    return {
      drawer: false,

    };
  },
  methods: {
    navigate(section: string): void {
      this.$emit('navigate-to', section);
    },
    setNavbarIcon(){
      this.drawer = true;
      this.$emit('is-navbar-icon-active', this.drawer);
      this.drawer = false;
    },
    scrollToSection(section: string): void {
      scrollService.scrollToSection(section);
    }
    

  },
  emits: ['navigate-to', 'is-navbar-icon-active']
});

</script>

<style scoped>
/* Force transparency - IMPORTANT: Use both scoped and unscoped */
.transparent-navbar {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
}

.v-app-bar {
  z-index: 1000;
}
</style>
